import QueryString from "qs";
import mainAxios from "../api/mainAxios";

export const setEnregistresActiveOnglet = (onglet) => ({
  type: "SET_ENREGISTRES_ACTIVE_ONGLET",
  payload: onglet,
});

export const setEnregistresSingleProgramId = (programId) => ({
  type: "SET_ENREGISTRES_SINGLE_PROGRAM_ID",
  payload: programId,
});

export const addEnregistresOpenLot = (lotId) => ({
  type: "ADD_ENREGISTRES_OPEN_LOT",
  payload: lotId,
});

export const removeEnregistresOpenLot = (lotId) => ({
  type: "REMOVE_ENREGISTRES_OPEN_LOT",
  payload: lotId,
});

export const fetchEnregistresSingleLot = (documentId) => {
  return async (dispatch) => {
    dispatch({
      type: "FETCH_ENREGISTRES_SINGLE_LOT_REQUEST",
      payload: documentId,
    });

    const query = QueryString.stringify({
      populate: {
        geo_orientations: { fields: ["orientation", "documentId"] },
        images: {
          populate: { image: { fields: ["url"] } },
        },
        programme_parent: {
          populate: {
            promoteur: true,
            lots: {
              populate: {
                images: { populate: { image: { fields: ["url"] } } },
              },
            },
            documents_pdfs: true,
            images: {
              populate: { image: { fields: ["url"] } },
            },
          },
        },
        documents_pdfs: {
          populate: "*",
        },
        project_types: {
          populate: "*",
        },
      },
    });

    try {
      const response = await mainAxios.get(`/api/lots/${documentId}?${query}`);

      const lotData = {
        ...response.data.data,
        id: documentId,
      };

      dispatch({
        type: "FETCH_ENREGISTRES_SINGLE_LOT_SUCCESS",
        payload: lotData,
      });
    } catch (error) {
      console.error("Error fetching lot:", error);
      dispatch({
        type: "FETCH_ENREGISTRES_SINGLE_LOT_FAILURE",
        payload: error.message,
        meta: { documentId },
      });
    }
  };
};
